import { useParams } from 'react-router-dom';
import { useDemoContractAnalysis } from '@/hooks/contracts/useDemoContractAnalysis';
import ContractAnalysis from './ContractAnalysis';
import type { GetContractResponseContent } from 'src/types/contract.types';

export const ContractAnalysisDemoRouter = () => {
  const { contractId } = useParams<{ contractId: string }>();
  const { getDemoContractById, demoContractIds } = useDemoContractAnalysis();

  const contract: GetContractResponseContent | undefined = contractId
    ? getDemoContractById(contractId)
    : undefined;

  if (!contract) {
    return (
      <div className="error-container" style={{ padding: '2rem', textAlign: 'center' }}>
        <h3>Contract not found</h3>
        <p>The demo contract with ID "{contractId}" was not found.</p>
        <p>Available contracts: {Object.values(demoContractIds).join(', ')}</p>
      </div>
    );
  }
  
  return <ContractAnalysis providedContract={contract} isDemo={true} />;
};
